import { combineReducers } from "redux";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import { LoginStore } from "../containers/Login/Store/reducer";
import { RegisterStore } from "../containers/Register/Store/reducer";
import { UsersStore } from "../containers/users/Store/reducer";
import { AddAzureAccountStore } from "../containers/users/Store/reducer";
import { AzureStore } from "../containers/azure/Store/reducer";
import { AzureBillStore } from "../containers/azurebilling/Store/reducer";
import {
  AzureForecastBillStore,
  AzureDailyForecastBillStore,
  AzureResourcegroupForecastBillStore,
  AzureLocationForecastBillStore,
} from "../containers/azureForecastbilling/Store/reducer";
import { AzureSubStore } from "../containers/azuresubcription/Store/reducer";
import { AzureActivityLogsStore } from "../containers/azureactivitylogs/Store/reducer";
import { AzureVmsStore } from "../containers/azurevms/Store/reducer";
import { AzureVmsImagesStore } from "../containers/azurevmsimages/Store/reducer";
import { AzureDBStore } from "../containers/azuredatabases/Store/reducer";
import { AzureStorageStore } from "../containers/azurestorageaccounts/Store/reducer";
import { AzureSiteStore } from "../containers/azuresites/Store/reducer";
import { AzureFunctionalAppStore } from "../containers/azurefunctionalapp/Store/reducer";
import { AzureLoadBalancerStore } from "../containers/azureloadbalancer/Store/reducer";
import { AzureAlertRulesStore } from "../containers/azurealertrules/Store/reducer";
import { AzureActiveAlertStore } from "../containers/azureactivealert/Store/reducer";
import { AzureCDNStore } from "../containers/azurecdn/Store/reducer";
import { AzureMonitorStorageAccountStore } from "../containers/azuremonitorstorageaccounts/Store/reducer";
import {
  AzureMonitorApplicationsStore,
  AzureMonitorApplicationsParamsStore,
} from "../containers/azuremonitorapplications/Store/reducer";
import { AzureMetricsRequestStore } from "../containers/azuremetricsrequest/Store/reducer";
import { AzureMetricsResponseStore } from "../containers/azuremetricsresponse/Store/reducer";
import { AzureMetricsAvailabilityStore } from "../containers/azuremetricsavailability/Store/reducer";
import { AzureMetricsLogsStore } from "../containers/azuremetricslogs/Store/reducer";
import { AzureConsoleLogsStore } from "../containers/azureconsolelogs/Store/reducer";
import {
  AzureDashboardDetailsStore,
  AzureDashboardServicesDetailsStore,
  ResourceGroupNameStore,
} from "../containers/azuredashboarddetails/Store/reducer";
import { AzureMetricsFailedStore } from "../containers/azuremetricsfailed/Store/reducer";
import { AzureDatabasePerformanceInsightStore } from "../containers/azuredatabaseperformanceinsight/Store/reducer";
import { PreviousAlertsStore } from "../containers/azurepreviousalertrules/Store";
import { CloudProviderStore } from "../containers/CloudProvider/Store";
import { AddGCPAccountStore } from "../containers/users/Store/gcpReducer";
import { GCPComputeInstancesStore } from "../containers/gcpComputeInstances/Store/reducer";
import { GCPCloudRunStore } from "../containers/gcpCloudRun/Store/reducer";
import { GCPSecretManagerStore } from "../containers/gcpSecretManager/Store/reducer";
const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  LoginStore: persistReducer(persistConfig, LoginStore),
  RegisterStore,
  UsersStore,
  AddAzureAccountStore,
  AzureStore,
  AzureDatabasePerformanceInsightStore,
  AzureBillStore,
  AzureForecastBillStore,
  AzureDailyForecastBillStore,
  AzureResourcegroupForecastBillStore,
  AzureLocationForecastBillStore,
  AzureSubStore,
  AzureActivityLogsStore,
  AzureVmsStore,
  AzureVmsImagesStore,
  AzureDBStore,
  AzureStorageStore,
  AzureSiteStore,
  AzureFunctionalAppStore,
  AzureLoadBalancerStore,
  AzureAlertRulesStore,
  AzureActiveAlertStore,
  AzureMonitorStorageAccountStore,
  AzureMonitorApplicationsStore,
  AzureMonitorApplicationsParamsStore,
  AzureCDNStore,
  AzureMetricsRequestStore,
  AzureMetricsResponseStore,
  AzureMetricsAvailabilityStore,
  AzureMetricsLogsStore,
  AzureConsoleLogsStore,
  AzureDashboardDetailsStore,
  AzureDashboardServicesDetailsStore,
  ResourceGroupNameStore,
  AzureMetricsFailedStore,
  PreviousAlertsStore,
  CloudProviderStore: persistReducer(persistConfig, CloudProviderStore),
  AddGCPAccountStore,
  GCPComputeInstancesStore,
  GCPCloudRunStore,
  GCPSecretManagerStore,
});

export default rootReducer;
